import { StyleProp, ViewStyle } from "react-native";
import BottomPopInMenu from "src/components/BottomPopInMenu";
import GatheringUploadPhotosButton from "../../../GatheringUploadPhotosButton";

const FloatingUpload = ({
	show,
	menuStyle,
	extraBottom,
}: {
	show: boolean;
	menuStyle?: StyleProp<ViewStyle>;
	extraBottom?: number;
}) => {
	return (
		<BottomPopInMenu
			show={show}
			style={menuStyle}
			extraBottom={extraBottom}
			group="GatheringMenu"
			weight={1000}
		>
			<GatheringUploadPhotosButton isAvailable={show} sizeVariant="CircleLarge" />
		</BottomPopInMenu>
	);
};
export default FloatingUpload;
